import React, { Fragment, useState, useEffect, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import {
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  InputGroup,
} from 'react-bootstrap';
import app from '../../config/application';
import Card from 'components/Card/Card.jsx';
import Button from '../../components/CustomButton/CustomButton';
import language from '../../config/es';
import DataTable from 'react-data-table-component';
import LabelChargeData from '../../components/Label/labelChargeData';
import Select from 'react-select';
import Switch from 'react-bootstrap-switch';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import {
  findWithPageByFilter,
  countPageByFilter,
  customerUpdateState,
} from '../../redux/client.duck';
import { findSocieties } from '../../redux/society.duck';
import { findByConcept } from '../../redux/type.duck';
import { es_vacio } from 'config/validate';
//Session user
import SessionConfig from '../../config/session_config';
import { getServerTableProps } from './shared/serverTableProps';

const Monitor = () => {
  const ref = useRef();
  const dispatch = useAppDispatch();
  let [loadingUpdate] = useState(false);
  const [society, setSociety] = useState({ value: 0, label: '', error: '' });
  const [state, setState] = useState({ value: '', label: '', error: '' });
  const [filterCodeClient, setFilterCodeClient] = useState('');
  const [showloadingSociety, setShowloadingSociety] = useState(false);
  const [filterEnable, setFilterEnable] = useState('');
  const [data, setData] = useState({
    columns: [],
    societies: [],
    pendingData: false,
    enable: true,
    page: 0,
    size: 10,
    totalRows: 0,
    clients: [],
    options: { year: 'numeric', month: 'numeric', day: 'numeric' },
    optionsTime: { hour: 'numeric', minute: 'numeric' },
    client: { value: 0, label: '' },
    auth: JSON.parse(sessionStorage.getItem('user')),
  });
  loadingUpdate = useSelector((store) => store.clientReducer.loadingUpdate);
  data.totalRows = useSelector((store) => store.clientReducer.totalRows);
  data.clients = useSelector((store) => store.clientReducer.clientsSAP);
  data.societies = useSelector((store) => store.societyReducer.societies);
  const states = useSelector((store) => store.typeReducer.types);
  //ciclo de vida ---------------------------------------------------
  useEffect(() => {
    void loadSocieties();
    initTable();
    void loadDataStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
  }, [data]);
  useEffect(() => {
    data.pendingData = false;
    data.enable = true;
    refreshState();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.clients]);
  useEffect(() => {
    if (data.societies.length > 0) {
      let societyTemp = {
        value: data.societies[0].value,
        label: data.societies[0].label,
        error: '',
      };
      setSociety(societyTemp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.societies]);

  //handlers ---------------------------------------------------
  const onChange = (event) => {
    if (event.target.name === 'code') {
      setFilterCodeClient(event.target.value);
    }
    refreshState();
  };
  const refreshState = () => {
    setData({
      ...data,
    });
  };
  const handlePerRowsChange = async (perPage, page) => {
    data.size = perPage;
    data.page = Number.parseInt(page) - 1;
    if (data.page < 0) {
      data.page = 0;
    }
    data.pendingData = true;
    refreshState();
    void loadData();
  };
  const handlePageChange = async (page) => {
    data.page = Number.parseInt(page) - 1;
    if (data.page < 0) {
      data.page = 0;
    }
    data.pendingData = true;
    refreshState();
    void loadData();
  };

  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    });
  };

  //funciones ---------------------------------------------------
  const loadDataStates = async () => {
    await dispatch(findByConcept(app.data.types.statusCustomer));
  };
  const search = async () => {
    setFilterEnable(filterCodeClient);
    data.pendingData = true;
    data.enable = false;
    refreshState();
    await loadCount();
    await loadData();
  };

  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    setShowloadingSociety(true);
  };

  const loadData = async () => {
    const json = {
      username: data.auth.id.user.username,
      filter: filterCodeClient,
      length: data.size,
      page: data.page,
      society: society.value,
      state: state?.code?state?.code:'',
    };
    await dispatch(findWithPageByFilter(json));
  };
  const loadCount = async () => {
    const json = {
      username: data.auth.id.user.username,
      filter: filterCodeClient,
      society: society.value,
      state: state?.code,
    };
    await dispatch(countPageByFilter(json));
  };
  const initTable = () => {
    data.columns = [
      {
        name: language.messages.client.state,
        sortable: false,
        wrap: true,
        width: '140px',
        cell: (row) => (
          <span>
            <div className="text-primary">
              <Switch
                id={row.id}
                row={row}
                onText={language.messages.lblYes}
                offText={language.messages.lblNo}
                defaultValue={row.status === 1}
                onChange={SwitchChange}
              />
              {row.messageResponse ? (
                <LabelChargeData
                  showloading={loadingUpdate}
                  label={language.messages.lblLoadingSave}
                />
              ) : null}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.client.lblName,
        sortable: false,
        wrap: true,
        width: '300px',
        cell: (row) => (
          <span>
            <div className=" small-font text-uppercase ">{row.name}</div>
            <div
              className={
                'text-uppercase badge  ' +
                (row.status === 1 ? 'bg-primary' : 'bg-danger')
              }
            >
              {row.status === 1 ? 'Activo' : 'Inactivo'}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.client.lblDocument,
        sortable: false,
        wrap: true,
        width: '200px',
        cell: (row) => (
          <span>
            <div className=" small-font text-uppercase ">{row.ci}</div>
          </span>
        ),
      },
      {
        name: language.messages.client.lblCodeSap,
        sortable: false,
        wrap: true,
        width: '150px',
        cell: (row) => (
          <span>
            <div className="text-uppercase text-primary"> {row.code}</div>
          </span>
        ),
      },
      {
        name: language.messages.client.lblCountry,
        sortable: false,
        wrap: true,
        width: '150px',
        cell: (row) => (
          <span>
            <div className="text-uppercase small-font ">
              {row.country === null ? '' : row.country.name}
            </div>
            <div className="badge bg-secondary">{row.codeCountry}</div>
          </span>
        ),
      },
      {
        name: language.messages.client.lblTypeDocument,
        sortable: false,
        wrap: true,
        width: '220px',
        cell: (row) => (
          <span>
            <div className="text-uppercase small-font ">
              {row.typeDocument === null ? '' : row.typeDocument.name}
            </div>
            <div className="badge bg-secondary">{row.codeDocumentClient}</div>
          </span>
        ),
      },
    ];
    updateState(data.columns, 'columns');
  };
  const SwitchChange = async (elm, state) => {
    elm.props.row.status = state ? 1 : 0;
    elm.props.row.messageResponse = elm.props.row.id;

    let json = {
      society: elm.props.row.societyId,
      code: elm.props.row.id,
      state: state ? 1 : 0,
    };
    let username = data.auth.id.user.username;
    initTable();
    await dispatch(customerUpdateState(username, json));
    elm.props.row.messageResponse = '';
    initTable();
  };
  const updateSelect = async (value, id) => {
    setSociety(value);
  };

  //render----------------------------------------------------------
  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <div className="main-content">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                icono=" fa  fa-filter"
                title={language.messages.title_filter}
                content={
                  <Fragment>
                    <Row >
                      <Col sm={12} md={3} lg={3} xl={3}>
                        <h6 className="title">
                          {language.messages.conciliation.society}
                        </h6>
                        <LabelChargeData showloading={showloadingSociety} />
                        <FormGroup>
                          <Select classNamePrefix="ui-select"
                            placeholder={language.messages.lblSingleSelect}
                            name="society"
                            options={data.societies}
                            className="text-uppercase small-font"
                            value={{
                              value: society.value,
                              label: society.label,
                            }}
                            onChange={(value) => {
                              void updateSelect(value, 'society');
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={3} lg={3}>
                        <h6 className="title">
                          {language.messages.client.lblFilter}
                        </h6>
                        <InputGroup className="mb-3" size="sm">
                          <Form.Control
                            size="sm"
                            type="text"
                            name="code"
                            id="code"
                            value={filterCodeClient}
                            onChange={onChange}
                          />
                          <Button
                            fill
                            secundary
                            id="button-addon2"
                            onClick={() => {
                              setFilterCodeClient('');
                            }}
                          >
                            <i className="fa fa-close"></i>
                          </Button>
                        </InputGroup>
                      </Col>
                      <Col sm={2} lg={2}>
                        <h6 className="title">
                          {language.messages.monitor.lblState}
                        </h6>
                        <FormGroup>
                          <Select classNamePrefix="ui-select"
                            isClearable={true}
                            maxMenuHeight={150}
                            placeholder={language.messages.lblSingleSelect}
                            name="state"
                            options={states}
                            className="text-uppercase small-font"
                            value={{
                              value: state.value,
                              label: state.label,
                            }}
                            onChange={(value) => {
                              setState(
                                value || { value: '', label: '',code:'' }
                              );
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={12} lg={2}>
                        <h6 className="title">&nbsp;&nbsp;</h6>
                        <Button
                          disabled={!data.enable}
                          info
                          fill
                          type="button"
                          onClick={search}
                        >
                          <i className="fa fa-search"></i>{' '}
                          {language.messages.client.lblSearch}
                        </Button>
                      </Col>
                    </Row>
                    <hr />
                    <div className="fresh-datatables">
                      <DataTable
                        title={
                          <Fragment>
                            <Row>
                              <Col>
                                <div>{language.messages.client.title}</div>
                              </Col>
                            </Row>
                            <div>
                              <span className="text-primary font-size-11">
                                {society.label}
                              </span>
                              <span className=" font-size-11">
                                {es_vacio(filterEnable)
                                  ? ''
                                  : language.messages.client.filter +
                                    ': ' +
                                    filterEnable}
                              </span>
                            </div>
                          </Fragment>
                        }
                        data={data.clients}
                        columns={data.columns}
                        {...getServerTableProps({
                          data,
                          scrollHeight: '600px',
                          onChangeRowsPerPage: handlePerRowsChange,
                          onChangePage: handlePageChange,
                        })}
                      />
                    </div>
                  </Fragment>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

const App = () => (
  <ToastProvider>
    <Monitor />
  </ToastProvider>
);
export default App;
